import { render, staticRenderFns } from "./vc-date-select.vue?vue&type=template&id=787ff948&scoped=true&"
import script from "./vc-date-select.vue?vue&type=script&lang=js&"
export * from "./vc-date-select.vue?vue&type=script&lang=js&"
import style0 from "./vc-date-select.vue?vue&type=style&index=0&id=787ff948&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ff948",
  null
  
)

export default component.exports